export const trimDecimals=(number, maxDecimals=2)=>{
    const n=Number(number);
    if( isNaN(n) )
        return number;
    const factor = 10**maxDecimals;
    return Math.round(n*factor)/factor;
};
